import React from 'react';

import Overview from '../Overview';

export default function RootPath(props) {
  return <Overview {...props} />;
}
